import { MatDateFormats, MAT_DATE_FORMATS } from '@angular/material/core';
import { DELIVERED } from 'src/app/main/orders/utils/order-types.const';
export const imgUrl =
  'https://riteway-customerportal-static.s3.amazonaws.com/uploads/';

export const emailRegExp =
  '[a-zA-Z0-9.-_-]{1,}@[a-zA-Z0-9.-]{2,}[.]{1}[a-zA-Z]{2,}';

export const decimalReg = '^[0-9]d*(.d+)?$';

export const loaderCode = `<div class="app-loading" id="app-loading">
<div class="logo-loading"></div>
<svg class="spinner" viewBox="25 25 50 50">
  <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
</svg>
</div>`;

export enum Icons {
  Notes = 'custom_notes',
  Car = 'custom_car',
  Notification = 'custom_notifications',
  Dashboard = 'custom_dashboard',
  Availables = 'custom_availables',
  Orders = 'custom_orders',
  Damage = 'custom_damage',
  Delivered = 'custom_delivered',
  Payments = 'custom_payments',
  Camera = 'icon_camera',
  Adress = 'icon_address',
  Password = 'icon_password',
  Delete = 'icon_delete',
  Edit = 'icon_edit',
  EditGray = 'icon_edit_gris',
  Upload = 'icon_upload',
  Document = 'icon_document',
  Phone = 'icon_phone',
  Email = 'icon_email',
  User = 'icon_user',
  UserBlue = 'icon_user_blue',
  Leads = 'icon_leads',
  Task = 'icon_task',
  TotalProfit = 'icon_total_profit',
  AvgProfit = 'icon_avg_profit',
  Truck = 'icon_truck',
  CancelLead = 'icon_cancel_lead',
  ConvertLead = 'icon_convert',
  ReportCall = 'icon_report_call',
  ReportEmail = 'icon_report_email',
  TaskAssociated = 'icon_task_associated',
  ConvertToOrder = 'convert_to_order',
  ConvertToQuote = 'convert_to_quote',
  ConvertToCompany = 'convert_to_company',
  ConvertToOrderWhite = 'convert_to_order_white',
  ConvertToQuoteWhite = 'convert_to_quote_white',
  ConvertToCompanyWhite = 'convert_to_company_white',
  SelectDashboard = 'select_dashboard',
  Carrito = 'icon_carrito',
  Icon_From = 'icon _from_info',
  IconTo = 'icon_destination_info',
  IconVehiclesInfo = 'icon_vehicle_info',
  IconShipping = 'icon _shipping _info',
  IconUpload = 'icon_upload_g',
  CompanyForm = 'company_form',
  Clock = 'icon_clock',
  ShipperType = 'icon_shipper_melo',
  Reloj = 'icon_reloj',
  Units = 'icon_units',
  City = 'icon_city',
  CityBlue = 'icon_city_blue',
  State = 'icon_state',
  ZipCode = 'icon_zip_code',
  AddressOther = 'icon_address_other',
  Shipment = 'icon_shipment_melo',
  URL = 'icon_URL',
  Calendar = 'icon_calendar',
  OtherData = 'icon_other_data',
  EmailYellow = 'icon_email_yellow',
  CalRed = 'icon_phone_blue',
  TaskGreen = 'icon_task_green',
  CancelGris = 'cancel_lead_gris',
  ReportCallGris = 'report_call_gris',
  ReportEmailGris = 'report_email_gris',
  TaskAssociatedGris = 'task_associated_gris',
  TaskAssociatedGray = 'associated_task_gray',
  AssignLeadGris = 'assign_sales_gris',
  EditGris = 'edit_gris',
  EditBlanco = 'edit_blanco',
  CancelBlanco = 'cancel_lead_blanco',
  ReportCallBlanco = 'report_call_blanco',
  ReportEmailBlanco = 'report_email_blanco',
  TaskAssociatedBlanco = 'task_associated_blanco',
  AssignLeadBlanco = 'assign_sales_blanco',
  GrayPhone = 'icon_phone_gray',
  WhitePhone = 'icon_phone_white',
  GrayEmail = 'icon_email_gray',
  WhiteEmail = 'icon_email_white',
  WhiteOthersNotes = 'icon_other_notes_white',
  GrayOthersNotes = 'icon_other_notes_gray',
  IconEditNote = 'icon_edit_note',
  AcceptGris = 'icon_accept_gris',
  DeclineGris = 'icon_decline_gris',
  OfferGris = 'icon_offer_gris',
  DeclineQuote = 'icon_decline',
  ShipInfo = 'icon_shipp_info',
  RouteDes = 'icon_destination',
  Route = 'icon_from',
  NewAdd = 'icon_new_add',
  RouteOr = 'icon_origin',
  QuoteForm = 'icon_quote_form',
  UserSky = 'icon_user_sky',
  VehiceInformation = 'icon_vehicle_information',
  AddressBlue = 'icon_address_other_blue',
  RelojBlue = 'icon_reloj_blue',
  ConvertIconWhite = 'icon_convert_white',
  ConvertIconGray = 'icon_convert_gray',
  NoteVisibleIcon = 'note_visible',
  NoteNoVisibleIcon = 'notes_no_ visible',
  GrossProfitIcon = 'gross_profit',
  AditionInformation = 'icon_additional_info',
  ActiveIcon = 'active_icon',
  InactiveIcon = 'inactive_icon',
  CalendarDarkBlue = 'calendar_darkblue',
  CalendarLightBlue = 'calendar_lightblue',
  PointerBlue = 'pointer_blue',
  PointerGrey = 'pointer_grey',
  IconFromOrder = 'icon_from_reloaded',
  IconToOrder = 'icon_to',
  AssociatedTaskGray = 'associated_task_gray',
  DownloadBlue = 'archive_blue',
  DownloadGray = 'archive_gray',
  ChatBtn = 'chat_btn',
  CallIcon = 'icon_call',
  FollowUpIcon = 'icon_followup',
  SendEmailIcon = 'icon_sendemail',
  NoDataIcon = 'icon_no_data',
  FilterIcon = 'filter_icon',
  DeleteBlue = 'delete_blue_option',
  IconCompany = 'icon_company',
  RiteWayActive = 'RiteWayActive',
  RiteWayInactive = 'RiteWayInactive',
  ShippingCost = 'icon_shipping_cost',
  UploadIcon = 'upload_icon',
  UploadIconWhite = 'upload_icon_white',
  ReactivateWhite = 'reactivate_white',
  ReactivateBlue = 'reactivate_blue',
  ReassignBlue = 'reassignSalesRep_blue',
  ReassignWhite = 'reassignSalesRep_white',
  UpdateGray = 'icon_edit_gray',
  CancelGray = 'icon_cancel_gray',
  CutDayIcon = 'cutDay',
  PayDayIcon = 'pay_day',
  SortICon = 'sort_gray',
  SortIconWhite = 'sort_white',
  SortIconBlue = 'sort_blue',
  SortASC = 'sort_desc',
  SortDESC = 'sort_asc',
  CreditCard = 'credit_card1',
  InsuranceDoc = 'insurance_doc',
  InsuranceDocIcon = 'icon_insurance_doc',
  ReassignGray = 'reassignSalesRepGray',
  IconPlus = 'IconPlus',
  IconGold = 'Icon_Gold',
  IconStandard = 'Icon_Standard',
  IconPlatinum = 'Icon_Platinum',
  TruckIcon = 'in_transit_icon',
  Destination = 'goal',
  CurrentPosition = 'current_point',
  MarkBlue = 'mark_blue',
  MarkWhite = 'mark_white',
  UnmarkBlue = 'unmark_blue',
  UnmarkWhite = 'unmark_white',
  Quick = 'quick',
  IconTruckWhite = 'icon_truck_white'
}

export const ALL_LABEL = 'All';

export const TESTING_COMPANY = {
  companyAdmin: {
    id: 2916,
    name: 'Johan',
    last_name: 'Zapata H',
    username: 'johanzahe@outlook.com',
    password: '$2b$10$IMJ.tOXdCfDpv52hE1C/hebMP7NQUecptOSCRkEdFOt1YtTVJxoBa',
    photo: 'users/user2916/profile_photo/IMG_20200711_220132_326.jpg',
    phone: 'null',
    token:
      'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MjkxNiwiaWF0IjoxNTk1NTk4OTM3LCJleHAiOjE1OTkxOTg5Mzd9.7fkEhoI9YBsATTLy1G6IH0JQ4Cs4vb-1cScLPpJ-uvM',
    enabled: true,
    company_id: 2109,
    rol_id: 12,
    role: { id: 12, name: 'customer_admin' }
  },
  id: 2109,
  name: 'Johanesburgor',
  photo: 'company_2109/profile_photo/logo-h.png',
  email: 'johanzahe@outlook.com',
  phone: '111-111-1111',
  additional_phone: '111-111-1111',
  address: 'Testing Johan Address',
  status: true,
  company_type_id: 2,
  fax: null,
  city_id: null,
  zipcode_id: null,
  createdAt: '2020-07-22T01:13:34.822Z',
  updatedAt: '2020-07-22T02:38:15.824Z',
  deletedAt: null,
  customerDetail: {
    id: 51,
    company_id: 2109,
    operator_id: 2864,
    show_carriers: false,
    shipper_type: 'Commercial',
    operatorUser: {
      id: 2864,
      name: 'Juan David U',
      last_name: 'Loaiza',
      username: 'loaiza.boetero.juandavid@gmail.com',
      password: '$2b$10$IMJ.tOXdCfDpv52hE1C/hebMP7NQUecptOSCRkEdFOt1YtTVJxoBa',
      photo: 'users/user2864/profile_photo/ProfilePicture.jpg',
      phone: '123-456-7890',
      token:
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6Mjg2NCwiaWF0IjoxNTk1NjAxOTkzLCJleHAiOjE1OTkyMDE5OTN9.i0I29SJCXWZ-0i-fJSwpsW0tuDVJ6LUO5ppTK-YynPQ',
      enabled: true,
      company_id: 2015,
      rol_id: 2
    }
  },
  users: [
    {
      id: 2916,
      name: 'Johan',
      last_name: 'Zapata H',
      username: 'johanzahe@outlook.com',
      password: '$2b$10$IMJ.tOXdCfDpv52hE1C/hebMP7NQUecptOSCRkEdFOt1YtTVJxoBa',
      photo: 'users/user2916/profile_photo/IMG_20200711_220132_326.jpg',
      phone: 'null',
      token:
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MjkxNiwiaWF0IjoxNTk1NTk4OTM3LCJleHAiOjE1OTkxOTg5Mzd9.7fkEhoI9YBsATTLy1G6IH0JQ4Cs4vb-1cScLPpJ-uvM',
      enabled: true,
      company_id: 2109,
      rol_id: 12,
      role: { id: 12, name: 'customer_admin' }
    }
  ]
};

export const QUOTE_FORM_TEMPLATE = {
  payment_method: 1,
  payment_receive_id: 1,
  source_name: 'Unknown',
  estimated_ship_date: new Date(),
  trailer: { id: -1, name: 'unknow' },
  additional_information: '',
  special_instruction_central_dispatch: ''
};

export const COMPANY_OPTIONS = [
  {
    id: 'ALL',
    name: 'ALL'
  },
  {
    id: 'RITEWAY',
    name: 'RITEWAY'
  },
  {
    id: 'MERCURY',
    name: 'MERCURY'
  }
];

export enum PrequalificationIdentifierType {
  MC = 'MC',
  DOT = 'DOT'
}

export enum PrequalificationMode {
  PREQUALIFICATION_FROM = 'PREQUAL_FROM',
  PREQUALIFICATION_RESPONSE = 'PREQUALIFICATION_RESPONSE'
}

export enum PrequalificationAction {
  SEND_INVITE = 'SEND_INVITE',
  ADD_CARRIER = 'ADD_CARRIER',
  VIEW_CARRIER = 'VIEW_CARRIER'
}

export enum RIMSResponseStatus {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR'
}

export enum PrequalificationButtonLabel {
  SEND_INVITE = 'Send Invite',
  ADD_CARRIER = 'Add Carrier',
  VIEW_CARRIER = 'View Carrier',
  SELECT_CARRIER = 'Select',
  INVITE_SENT = 'Invite Sent',
  RESEND_INVITE = 'Resend Invite'
}

export const DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const DATE_FORMAT_FOLLOWUP_HISTORY = 'MM/dd/yyyy hh:mm a';

export const DROPDOWN_OPTIONS_YES = 'yes';
export const DROPDOWN_OPTIONS_NO = 'no';
export const MAX_FILE_SIZE_FOR_BOL = 10;
export const FILE_TYPES = [
  '.pdf',
  '.PDF',
  '.jpg',
  '.jpeg',
  '.png',
  '.doc',
  '.docx',
  '.txt',
  '.xml',
  '.xsl',
  'image/*'
].join();

export const SUPER_ADMIN_ROLE = 'super_admin';
export const PICKUP_DELIVERY_DATE = 'pickupDeliveryDate';
export const PICKUP_DELIVERY_DATE_STORE = 'PICKUP_DELIVERY_DATE_STORE';
export const ETA_ORDER = 'etaOrder';
export const ETA_ORDER_STORE = 'ETA_ORDER_STORE';
export const CUSTOM_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'MM/DD/YYYY'
  },
  display: {
    dateInput: 'MM/DD/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'MM/DD/YYYY',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};
export const ETA_OPTIONS = [
  { value: '6AM-8AM', label: '6AM-8AM' },
  { value: '8AM-10AM', label: '8AM-10AM' },
  { value: '10AM-12PM', label: '10AM-12PM' },
  { value: '12PM-2PM', label: '12PM-2PM' },
  { value: '2PM-4PM', label: '2PM-4PM' },
  { value: '4PM-6PM', label: '4PM-6PM' },
  { value: '6PM-8PM', label: '6PM-8PM' }
];
export const NOON_UTC_TIME = 'T12:00:00.000Z';

export const enum Timezone {
  ALL = 'ALL',
  EST = 'EST',
  CST = 'CST',
  MST = 'MST',
  PST = 'PST',
  NA = 'N/A'
}
export const TIMEZONE_LIST: Array<any> = [
  { value: Timezone.ALL, viewValue: Timezone.ALL },
  { value: Timezone.EST, viewValue: Timezone.EST },
  { value: Timezone.CST, viewValue: Timezone.CST },
  { value: Timezone.MST, viewValue: Timezone.MST },
  { value: Timezone.PST, viewValue: Timezone.PST },
  { value: Timezone.NA, viewValue: Timezone.NA }
];

// Prod

const JEFF_USER_ID = 848;
const CHRIS_GABA_USER_ID = 284300;
const DEV_SUPER_ADMIN = 202520;
const UAT_SUPER_ADMIN = 9527;
const PROD_SUPER_ADMIN = 264635;
const MATTHEW_USER_ID = 266665;
const HOWARD_USER_ID = 63164;
const REINALDO_USER_ID = 9533;
const PAUL_USER_ID = 64103;
const AsheleyHennessyUserId = 235871;
const DEV_DISPATCHER_ID = 983;
const MARIA_HARSHEY_USER_ID = 319787;

export const ALLOWED_USER_IDS_FOR_CARRIER_EMAIL_UPDATE = [
  AsheleyHennessyUserId,
  HOWARD_USER_ID,
  REINALDO_USER_ID,
  MARIA_HARSHEY_USER_ID
];

export const BACKUP_SUPER_DASHBOARD_IDS = [JEFF_USER_ID, CHRIS_GABA_USER_ID];
export const EXTENDED_DASHBOARD_USERS = [
  JEFF_USER_ID,
  DEV_SUPER_ADMIN,
  UAT_SUPER_ADMIN,
  PROD_SUPER_ADMIN
];
export const ALLOWED_USERS_FOR_CREATING_CARRIERS = [
  MATTHEW_USER_ID,
  HOWARD_USER_ID,
  REINALDO_USER_ID,
  PAUL_USER_ID,
  DEV_SUPER_ADMIN,
  UAT_SUPER_ADMIN,
  PROD_SUPER_ADMIN,
  MARIA_HARSHEY_USER_ID
];
export const ALLOWED_DISPATCHER_FOR_ON_HOLD = [
  HOWARD_USER_ID,
  DEV_DISPATCHER_ID
];
export const SUPPORT_PHONE = '954-369-4631';
export const ACH_CHECK_SUPPORT_PHONE = '888-688-8801 Ext. 5';
export const ACH_SUPPORT_EMAIL = 'speedpay@ritewaytransport.com';
export const CHECK_SUPPORT_EMAIL = 'ap@ritewaytransport.com';

export const PAYMENT_METHODS = {
  COD: 'COD - Cash on deliveryACH',
  CHECK: 'Billing - Check',
  ACH: 'Billing - ACH'
};

export const PHONE_STATUSES = {
  INVALID: [
    'landline',
    'pager',
    'invalid',
    'sharedCost',
    'uan',
    'fixedVoip',
    'tollFree'
  ],
  VALID: ['mobile', 'personal', 'premium'],
  PARTIALLY_VALID: ['nonFixedVoip', 'voicemail', 'unknown']
};

export const STATUS_LABELS = {
  INVALID: 'invalid',
  VALID: 'valid',
  PARTIALLY_VALID: 'partially_valid'
};

export enum PAY_CYCLE {
  ON_CYCLE = 1,
  OFF_CYCLE = 2,
  NO_CYCLE = 0
}

export const BUSINESS_UNITS = [
  'Accounting',
  'Agents',
  'B2B',
  'BOM',
  'Corporate Dev',
  'Corporate Ops',
  'MGMT',
  'Operations',
  'POV',
  'RELO',
  'Stations',
  'Tech',
];

export enum Brand {
  RITEWAY = 'RITEWAY',
  MERCURY = 'MERCURY',
  SYCN = 'SYCN'
}

export const BRAND_OPTIONS = [
  { value: Brand.RITEWAY, label: 'Riteway' },
  { value: Brand.MERCURY, label: 'Mercury' },
  { value: Brand.SYCN, label: 'SYCN' }
];

export const ORDER_STATUSES = {
  HOLD: 'on_hold',
  TEXT_LOCATE_PICKUP: 'PickUp',
  TEXT_LOCATE_INTRANSIT: 'InTransit'
};

export const LOCATE_DRIVER_PING_ORDER_STATUSES = [
  'delivered',
  'cancelled',
  'damage'
];

export const SOURCE_OF_LOAD_OPTIONS: string[] = [
  'CENTRAL_DISPATCH',
  'SUPER_DISPATCH',
  'TRUCKSTOP',
  'DAT',
  'CARRIER_SALES_COVERED',
  'EMAIL',
  'LOAD_MATCH'
];

export const DISPATCH_THROUGH = {
  SUPER_DISPATCH: 'SUPER_DISPATCH',
  LOAD_GENIE: 'LOAD_GENIE',
  SUPER_DISPATCH_REQUEST: 'SUPER_DISPATCH_REQUEST',
  INSTANT_BOOKING: 'INSTANT_BOOKING',
  SUPER_DISPATCH_MANUAL: 'SUPER_DISPATCH_MANUAL'
};

export const HighwayClassificationStatus = {
  PASS: 'pass',
  PARTIAL_PASS: 'partial_pass',
  INCOMPLETE: 'incomplete',
  FAIL: 'fail',
  NOT_REGISTERED: 'not_registered',
  NOT_SYNCED: 'not_synced'
};

export const HighwayClassificationStatusLabel = {
  PASS: 'Pass',
  PARTIAL_PASS: 'Partial Pass',
  INCOMPLETE: 'Incomplete',
  FAIL: 'Fail',
  NOT_REGISTERED: 'Not Registered',
  NOT_SYNCED: 'Not Synced'
};

export const SUPER_DISPATCH_OPERATOR_USERNAME = 'superdispatchuser';

export const CARRIER_TABLE_COLUMNS = [
  'companyName',
  'hq',
  'identifiers',
  'dispatch',
  'laneCertainty',
  'fleetSize',
  'eldStatus',
  'assessment',
  'sendInvite'
];

export const VEHICLE_TABLE_COLUMNS = [
  'type',
  'plateNumber',
  'regState',
  'vin',
  'make',
  'associatedCarrier',
  'lastSeenDate'
];

export const EQUIPMENT_TYPES = [
  'van_trailers',
  'reefer_trailers',
  'flatbed_trailers',
  'tanker_trailers',
  'intermodal_trailers',
  'pneumatic_trailers',
  'dumps_trailers',
  'car_hauler_trailers',
  'double_drop_trailers',
  'drop_deck_trailers',
  'lowboy_trailers',
  'grain_trailers',
  'livestock_trailers',
  'heavy_haul_trailers',
  'total_observed_trailers'
];

export enum HighwayConnectionStatus {
  ONBOARDED = 'onboarded',
  NEEDS_TO_ONBOARD = 'needs_to_onboard',
  NEEDS_TO_ONBOARD_BUT_CAN_REMAIN_ACTIVE = 'needs_to_onboard_but_can_remain_active',
  DO_NOT_DISPATCH = 'do_not_dispatch'
}

export const COMMON_ACTION_KEYS = {
  ARROW_DOWN: 'ArrowDown',
  ARROW_UP: 'ArrowUp',
  ENTER: 'Enter'
};

export const DISPATCHERS_ALLOWED_TS_ORDER_CREATE = [
  'ah@ritewaytransport.com',
  'howie@ritewaytransport.com',
  'mgardner@ritewaytransport.com',
  'bmaclure@ritewaytransport.com',
  'scdsp2@gmail.com',
  'ms@ritewaytransport.com',
  'rmitchell@ritewaytransport.com'
];

export const SALES_REP_ALLOWED_TS_ORDER_CREATE = ['blair@ritewaytransport.com', 'hector@ritewaytransport.com'];

export const ROLES = {
  DISPATCHER: 'dispatcher',
  SALES_REP: 'sales_rep',
  SUPER_ADMIN: 'super_admin'
};

export const DISPATCH_THROUGH_ALL = 'ALL';

export const SD_DEFAULT_DRIVER = 'superdispatch_driver';
export const SD_DEFAULT_DRIVER_NAME = 'superdispatch driver';
export const SD_DEFAULT_DRIVER_EMAIL = 'sd_driver@superdispatch.com';

export const EXCLUDED_STATUSES_FOR_INSTANT_BOOKING = [9, 10, 14, 15];
export const ACCOUNT_PAYABLE_ROLE_ID = 13;

export const MAX_ORIGIN_AND_DESTINATION_EMAILS_LIMIT = 5;

export const MERCURY_SOURCE_NAME = 'Mercury';

export enum OrderTypes {
  ALL = 'ALL',
  RITEWAY = 'RITEWAY',
  MERCURY = 'MERCURY'
}

export const MERCHANT_TYPES = {
  RITEWAY: 'RITEWAY',
  MERCURY: 'MERCURY'
};

export const MERCURY_ORDER_TYPES = [
  { id: 'ALL', name: 'All' },
  { id: 'MVP', name: 'MVP' },
  { id: 'WHITE_GLOVE', name: 'White Glove' }
];

export enum MERCURY_TYPES {
  ALL = 'ALL',
  MVP = 'MVP',
  WHITE_GLOVE = 'WHITE_GLOVE'
}

export const CUSTOMER_NOT_ASSIGNED =
  "You're not assigned to this shipper. Please contact admin.";

export const SHIPPER_CONTACTABLE_THRESHOLD = 90;

export enum GL_COMPANY_TYPE {
  DEALERSHIP = 'DEALERSHIP',
  CORPORATE_DEALERSHIP_MEGADEALER = 'CORPORATE_DEALERSHIP_MEGADEALER',
  CHANNEL_PARTNER = 'CHANNEL_PARTNER',
  FLEET_LEASING_COMPANY = 'FLEET_LEASING_COMPANY',
  OEM = 'OEM',
  REMARKETING = 'REMARKETING',
  RENTAL_MOBILITY_PROVIDER = 'RENTAL_MOBILITY_PROVIDER',
  THREE_PL_MANAGED_TRANSPORTATION = 'THREE_PL_MANAGED_TRANSPORTATION',
  POV = 'POV',
  RELOCATION_MOVING_COMPANIES = 'RELOCATION_MOVING_COMPANIES',
  SPECIALIZED_HEAVY_HAUL = 'SPECIALIZED_HEAVY_HAUL',
  WHOLESALE = 'WHOLESALE',
  OTHER = 'OTHER'
}

export const GL_COMPANY_TYPE_OPTIONS = [
  {
    value: GL_COMPANY_TYPE.DEALERSHIP,
    label: 'Dealership',
    description: 'Franchised or independent retail dealers shipping inventory between stores, auctions, and customers. Their logistics needs are typically recurring, time-sensitive, and tied to sales or reconditioning cycles.'
  },
  {
    value: GL_COMPANY_TYPE.CORPORATE_DEALERSHIP_MEGADEALER,
    label: 'Corporate Dealership (MegaDealer)',
    description: 'Large multi-rooftop dealer groups with centralized decision-making, standardized processes, and high-volume recurring logistics. They require scalable pricing, unified reporting, and multi-location operational support.'
  },
  {
    value: GL_COMPANY_TYPE.CHANNEL_PARTNER,
    label: 'Channel Partner',
    description: 'A strategic partner who integrates SYCN into their platform or service, enabling shipping for their own customers. Often involves API connectivity, co-branded workflows, or embedded logistics.'
  },
  {
    value: GL_COMPANY_TYPE.FLEET_LEASING_COMPANY,
    label: 'Fleet / Leasing Company',
    description: 'Commercial fleet operators and leasing providers managing large vehicle portfolios, often requiring scheduled pick-ups, title coordination, storage, and nationwide coverage. Movements are typically planned, multi-unit, and repeatable.'
  },
  {
    value: GL_COMPANY_TYPE.OEM,
    label: 'OEM',
    description: 'Automakers, ports, and production entities moving new vehicles from manufacturing, yard, or port locations. Requirements often include strict SLA windows, visibility, VIN-level compliance, and specialized carrier vetting.'
  },
  {
    value: GL_COMPANY_TYPE.REMARKETING,
    label: 'Remarketing',
    description: 'Companies reselling off-lease, repossessed, fleet, or rental inventory through auctions or digital marketplaces. Logistics is fast-paced, multi-location, and closely tied to time-to-lot/sale KPIs.'
  },
  {
    value: GL_COMPANY_TYPE.RENTAL_MOBILITY_PROVIDER,
    label: 'Rental / Mobility Provider',
    description: 'Rental car companies or mobility operators rotating fleet units between branches, maintenance hubs, or disposal channels. Movements are frequent, operationally driven, and often multi-unit.'
  },
  {
    value: GL_COMPANY_TYPE.THREE_PL_MANAGED_TRANSPORTATION,
    label: '3PL/Managed Transportation',
    description: 'Third-party logistics firms or managed transportation providers using SYCN to fulfill automotive shipments for their own clients. They require reliable execution, transparent pricing, and robust reporting.'
  },
  {
    value: GL_COMPANY_TYPE.POV,
    label: 'POV',
    description: 'Individual consumers moving personal vehicles for relocation, purchase, or seasonal travel. Shipments are one-time or infrequent and require higher-touch communication and expectation management.'
  },
  {
    value: GL_COMPANY_TYPE.RELOCATION_MOVING_COMPANIES,
    label: 'Relocation / Moving Companies',
    description: 'Household goods and relocation service providers bundling vehicle transport into wider move packages. They rely on predictable pricing, consistent carrier quality, and clear scheduling.'
  },
  {
    value: GL_COMPANY_TYPE.SPECIALIZED_HEAVY_HAUL,
    label: 'Specialized Heavy Haul',
    description: 'Clients shipping oversized, commercial, or non-standard units requiring heavy-haul, lowboy, or specialty equipment. Movements demand expert routing, permits, and highly vetted carriers.'
  },
  {
    value: GL_COMPANY_TYPE.WHOLESALE,
    label: 'Wholesale',
    description: 'Traders or wholesalers moving inventory between auctions, lots, or wholesale partners. Logistics is frequent, transactional, and price-sensitive, with emphasis on speed to lot.'
  },
  {
    value: GL_COMPANY_TYPE.OTHER,
    label: 'Other',
    description: 'Any client that doesn’t clearly fall into the standard categories, including unique operational models or hybrid business types. Handled through a custom onboarding review to ensure proper pricing, compliance, and workflow setup.'
  }
];
export const CARRIER_CC_PAYMENT_RECEIVE_ID = 16;
export const VALID_ORDER_STATUS_FOR_CARRIER_CC_PAYMENT = ['dispatched', 'intransit', 'intransit_ontime', 'intransit_delay', 'picked_up', 'signed', 'not_signed', 'delivered'];

export const CASH_ACCOUNT_OPTIONS = [
  { label: '10000 - Cash', netsuite_sandbox_id: 1, netsuite_production_id: 134 },
  { label: '10104 - TD BANK', netsuite_sandbox_id: 139, netsuite_production_id: 139 },
  { label: '10203 - Chase 3771 OP Acct', netsuite_sandbox_id: 144, netsuite_production_id: 145 },
  { label: '25000 - Line of Credit', netsuite_sandbox_id: 243, netsuite_production_id: 256 },
  { label: '10050 - New Co Pass Through', netsuite_sandbox_id: 782, netsuite_production_id: 851 },
  { label: '67012 - Customer Write-Off Expense', netsuite_sandbox_id: 783, netsuite_production_id: 853 },
  { label: '67013 - Customer Rebates Expense', netsuite_sandbox_id: 784, netsuite_production_id: 854 },
  { label: '23222 - Accrual - Agent Commissions +90 RW', netsuite_sandbox_id: 670, netsuite_production_id: 241 },
  { label: '21095 - Unapplied Funds', netsuite_sandbox_id: 787, netsuite_production_id: 847 }
  // { label: '11050 - Unapplied Cash / Undeposited Funds', netsuite_sandbox_id: 156, netsuite_production_id: 158 },
  // { label: '41010 - Write-Offs', netsuite_sandbox_id: 304, netsuite_production_id: 322 },
];

export const VIN_LENGTH = 17;

export const USERS_ALLOWED_POST_TO_CD =['howie@ritewaytransport.com', 'reinaldo@ritewaytransport.com','agrisales@ritewaytransport.com','scdsp3@yopmail.com'];
